module.exports = __webpack_public_path__ + "img/Pham.9cc645fc.jpeg";